module.exports = __webpack_public_path__ + "img/vip_icon2@2x.59544553.png";